import store from "../../redux/store";

function GetUser() {
  var state = store.getState();
  if (!state || !state.user.user || !state.user.user.id) return null;
  return state.user.user;
}

store.subscribe(GetUser);

export default GetUser;
